import React, { FCC } from 'react';
import { INavItemContentProps } from './types';

// this is the default ComponentClass for rendering content inside a Navitem
export const NavItemContent: FCC<INavItemContentProps> = (props) => {
  return <div>{props.children}</div>;
};
